import { combineReducers } from 'redux';
import userLoggedIn from './loginReducer';
import {tenants} from  './tenantReducer';
import {tenant} from './tenantReducer';
import {artists} from  './artistReducer';
import {artist} from './artistReducer';
import {clauses} from  './clauseReducer';
import {clause} from './clauseReducer';
import {consents} from  './consentReducer';
import {consent} from './consentReducer';
import {kioskusers} from  './kioskuserReducer';
import {kioskuser} from './kioskuserReducer';
import {submissions} from  './submissionReducer';
import {submission} from './submissionReducer';
import {subscriptions} from './subscriptionReducer';
import {subscription} from './subscriptionReducer';

const rootReducer = combineReducers({
  userLoggedIn,
  tenants,
  tenant,
  artists,
  artist,
  clauses,
  clause,
  consents,
  consent,
  kioskusers,
  kioskuser,
  submissions,
  submission,
  subscriptions,
  subscription
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js